module.exports = __webpack_public_path__ + "5ab1c580f330c1b63edcade154f85452.jpg";